import posthog from 'posthog-js';
import mixpanel from 'mixpanel-browser';
import { browser } from '$app/environment';

const tokens =
    browser && location.host.endsWith('.factlines.com')
        ? {
              // production
              posthog: 'phc_gOMf2YEGVD5DdwaIcFWgTJa6DIuo2avWQC83OWOj6xj',
              mixpanel: 'afac7b377d1e070b4dc10d1d4c46b50a'
          }
        : {
              // development
              posthog: 'phc_NBrzVGzCKMwnEqI3Fr0T2UL98zj9T68rFY0PmmE3SH1',
              mixpanel: '40e5c1f51c2160a8fc5938f671cb8724'
          };

export function analyticsIsEnabled(): boolean {
    return browser && location.host.endsWith('.factlines.com');
}

export function initAnalytics() {
    if (!analyticsIsEnabled()) {
        return;
    }
    posthog.init(tokens.posthog, {
        api_host: 'https://phe.factlines.com',
        ui_host: 'https://eu.posthog.com'
    });

    mixpanel.init(tokens.mixpanel, {
        debug: false,
        track_pageview: true,
        persistence: 'cookie',
        api_host: 'https://d3abpqq9xprhx.cloudfront.net'
    });
}

export function trackEvent(eventName: string, data?: Record<string, string | number>) {
    if (!analyticsIsEnabled()) {
        return;
    }
    posthog.capture(eventName, data);
    mixpanel.track(eventName, data);
}

export function trackPageView() {
    if (!analyticsIsEnabled()) {
        return;
    }
    posthog.capture('$pageview');
    mixpanel.track_pageview();
}

export function identifyUser(email: string) {
    if (!analyticsIsEnabled()) {
        return;
    }
    posthog.identify(email, {
        email: email
    });
    mixpanel.identify(email);
}

export function resetAnalytics() {
    if (!analyticsIsEnabled()) {
        return;
    }
    mixpanel.reset();
    posthog.reset();
}
